<template>
  <div class="menu_add">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="编辑菜单"
      :visible.sync="dialogVisible"
      width="756px"
      custom-class="addoredit"
      @close="close"
    >
      <el-form ref="formDataRef" :model="formData" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="上级菜单:"
              prop="parentId"
              :rules="[{ required: true, message: '请选择上级菜单' }]"
            >
              <el-cascader
                v-model="formData.parentId"
                :options="treeData"
                :props="defaultProps"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="类型:"
              style="width: 100%"
              prop="resourceFlag"
              :rules="[{ required: true, message: '请选择类型' }]"
            >
              <el-select
                v-model="formData.resourceFlag"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="(t, i) in types"
                  :key="i"
                  :label="t.label"
                  :disabled="t.value === 3 && isRoot"
                  :value="t.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="formData.resourceFlag !== 3 ? 12 : 24">
            <el-form-item
              label="名称:"
              prop="title"
              :rules="[{ required: true, message: '请输入名称' }]"
            >
              <el-input
                v-model="formData.title"
                placeholder="请输入名称"
                maxlength="200"
              >
                <el-button
                  v-if="formData.resourceFlag !== 3"
                  slot="append"
                  icon="el-icon-search"
                  @click="showLocalMenu"
                />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="formData.resourceFlag !== 3"
              label="显示排序:"
              prop="sort"
              style="width: 100%"
              :rules="[{ required: true, message: '请输入序号' }]"
            >
              <el-input
                v-model.number="formData.sort"
                type="number"
                placeholder="请输入序号"
                maxlength="10"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.resourceFlag === 3">
          <el-col :span="24">
            <el-form-item
              label="资源URL:"
              style="width: 100%"
              prop="url"
              :rules="[{ required: true, message: '请输入资源URL' }]"
            >
              <el-input
                v-model="formData.url"
                placeholder="请输入资源URL"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.resourceFlag === 3">
          <el-col :span="24">
            <el-form-item
              label="资源页面标识"
              prop="htmlId"
              style="width: 100%"
              :rules="[{ required: true, message: '请输入资源页面标识' }]"
            >
              <el-input
                v-model="formData.htmlId"
                placeholder="请输入资源页面标识"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.resourceFlag !== 3">
          <el-col :span="12">
            <el-form-item
              label="路由名称:"
              style="width: 100%"
              prop="name"
              :rules="[{ required: true, message: '请输入路由名称' }]"
            >
              <el-input
                v-model="formData.name"
                placeholder="请输入路由名称"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="路由地址:"
              prop="path"
              style="width: 100%"
              :rules="[{ required: true, message: '请输入路由地址' }]"
            >
              <el-input
                v-model="formData.path"
                placeholder="请输入路由地址"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.resourceFlag !== 3">
          <el-col :span="12">
            <el-form-item
              label="路由组件:"
              prop="component"
              style="width: 100%"
              :rules="[{ required: true, message: '请输入路由组件' }]"
            >
              <el-input
                v-model="formData.component"
                placeholder="请输入路由组件"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重定向:" prop="redirect" style="width: 100%">
              <el-input
                v-model="formData.redirect"
                placeholder="请输入重定向"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.resourceFlag !== 3">
          <el-col :span="12">
            <el-form-item
              label="是否可见:"
              style="width: 100%"
              prop="hidden"
              :rules="[{ required: true, message: '请选择' }]"
            >
              <el-radio-group v-model="formData.hidden">
                <el-radio :label="false">是</el-radio>
                <el-radio :label="true">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否展示二级:" prop="leaf" style="width: 100%">
              <el-radio-group v-model="formData.leaf">
                <el-radio :label="false">是</el-radio>
                <el-radio :label="true">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.resourceFlag !== 3">
          <el-col :span="24">
            <el-form-item label="图标:" prop="icon" style="width: 100%">
              <el-input
                v-model="formData.icon"
                placeholder="请输入图标名称"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述:" prop="description" style="width: 100%">
              <el-input
                v-model="formData.description"
                maxlength="200"
                type="textarea"
                placeholder="请输入描述"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="loading"
          @click="sureDelete"
        >确 认</el-button>
      </div>
    </el-dialog>
    <localMenu ref="localMenuRef" @change="localMenuChange" />
  </div>
</template>
<script>
import { updateResource } from '@/assets/js/resource'
import localMenu from './localMenu.vue'
export default {
  components: { localMenu },
  props: {
    tree: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      defaultProps: {
        emitPath: false,
        checkStrictly: true,
        value: 'resourceId',
        children: 'items',
        label: 'title'
      },
      types: [
        {
          label: '超级管理员的路由',
          value: 0
        }, {
          label: '菜单路由',
          value: 1
        }, {
          label: '路由接口',
          value: 2
        }, {
          label: '接口级限制',
          value: 3
        }
      ],
      dialogVisible: false,
      formData: {
        title: '',
        name: '',
        path: '',
        component: ''
      }
    }
  },
  computed: {
    treeData() {
      const data = this.buildFilterTree(this.tree, (b) => {
        return b.resourceId !== this.formData.resourceId
      })
      return [{
        disabled: this.formData.resourceFlag === 3,
        resourceId: 0,
        title: '根',
        items: data
      }]
    },
    isRoot() {
      return this.formData.parentId === 0
    }
  },
  watch: {
    isRoot() {
      if (this.isRoot) {
        if (!this.formData.component) {
          this.formData.component = 'Home'
        }
        if (!this.formData.name) {
          this.formData.name = 'Home'
        }
        if (!this.formData.path) {
          this.formData.path = '/'
        }
      }
    }
  },
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {
    localMenuChange(menu) {
      this.formData.name = menu.name
      this.formData.path = menu.path
      this.formData.component = menu.component
      if (menu.meta && menu.meta.title) {
        this.formData.title = menu.meta.title
      }
    },
    showLocalMenu() {
      this.$refs.localMenuRef.show()
    },
    buildFilterTree(arr, fun) {
      const data = arr.filter(fun).map((item) => {
        item = Object.assign({}, item)
        if (item.children) {
          // 递归循环
          item.items = this.buildFilterTree(item.children, fun)
        }
        return item
      }).sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      return data
    },
    close() {
      this.$refs.formDataRef.clearValidate()
      this.$nextTick(() => {
        this.formData = {
          title: '',
          name: '',
          path: '',
          component: ''
        }
        this.dialogVisible = false
      })
    },
    show(row) {
      this.dialogVisible = true
      this.formData = Object.assign({}, row)
      this.$nextTick(() => {
        this.$refs.formDataRef.clearValidate()
      })
    },
    sureDelete() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.formData.parentId === this.formData.resourceId) {
            this.$message({
              type: 'warning',
              message: '父菜单不能选择自己'
            })
            this.loading = false
            return
          }
          const params = Object.assign({}, this.formData)
          updateResource(params).then(res => {
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.close()
              this.$emit('refresh')
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.menu_add {
  // background-color: white;
  background-color: #eef1f9;
  padding: 15px;
  .title {
    background-color: white;
    width: 100%;
    height: 50px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/.el-dialog__body {
    margin: 20px 0;
    padding: 0 60px;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox_down.png");
    background-size: 100% 100%;
  }
  /deep/.el-radio__input .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox.png");
    background-size: 100% 100%;
    border-radius: 0;
    border: none;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    background: none;
  }
}
</style>
